import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { ResidentesService } from 'src/app/services/residentes.service';
import { ResPersona, ResRegistro } from 'src/app/models';

export interface PadronTabla {
  id: number;
  nombreCompleto: string;
  noTarjeta: string;
  fechaRegistro: string;
  estatus: number;
  crudo: any;
}


@Component({
  selector: 'app-padron-residentes',
  templateUrl: './padron-residentes.component.html',
  styleUrls: ['./padron-residentes.component.scss']
})
export class PadronResidentesComponent implements OnInit {

  activeTab: 'padron' | 'pendientes' = 'padron';
  residenteForm!: FormGroup;
  formNuevoEditarResidente: boolean = false;
  mostrarModalAsignar: boolean = false;
  filaEdicion: number = -1;
  padronId: number = -1;
  rows: PadronTabla[] = [];
  tempRows: PadronTabla[] = [];
  itemsPagina: number = 12;
  filas: ResRegistro[] = [];
  tempFilas: ResRegistro [] = [];
  allpersonas: ResPersona [] = [];
  //variables combo asignar
  busquedaCombo: string = '';
  personasFiltradas: ResPersona[] = [];
  personaSeleccionada: ResPersona | null = null;
  desplegado: boolean = false;
  

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private residentesService: ResidentesService
  ) {}

  ngOnInit(): void {
    this.obtenerPadron();
    this.obtenerPreRegistros();
    this.obtenerPersonas();
  }

  obtenerPadron(){
    this.residentesService.getPadron()
      .then(respuesta_api =>{
        if (respuesta_api.success){
          const datosMapeados = respuesta_api.data.map((item)=>({
            id: item.id,
            nombreCompleto : (item.persona)? `${item.persona.nombre} ${item.persona.apellido_paterno} ${item.persona.apellido_materno}`.trim() : 'REGISTRO COMPLETO PENDIENTE',
            noTarjeta: item.no_tarjeta,
            fechaRegistro: item.fecha_registro,
            estatus: item.estatus,
            crudo: item,
          }))
          this.tempRows = [...datosMapeados];
          this.rows = datosMapeados;
        }else{
          this.toastr.error(respuesta_api.message);
        }
      });
  }

  obtenerPreRegistros(){
    this.residentesService.getPreRegistros()
      .then(respuesta_api => {
        if(respuesta_api.success){
          const datos = respuesta_api.data;
          this.tempFilas = [...datos];
          this.filas = datos;
        } else {
          this.toastr.error(respuesta_api.message);
        }
      })
  }

  obtenerPersonas(){
    this.residentesService.getPersonas().then(
      respuesta_api => {
        if(respuesta_api.success){
          const datos = respuesta_api.data;
          this.allpersonas = [...datos];
          this.personasFiltradas = datos;
        }else{
          this.toastr.error(respuesta_api.message);
        }
      }
    )
  }

  filtrar(event: any): void {
    const val = event.target.value.toLowerCase().trim();

    if (!val) {
  
      this.rows = [...this.tempRows];
      return;
    }

    const temp = this.tempRows.filter(row => {
      return (row.nombreCompleto.toLowerCase().includes(val) || row.noTarjeta.toLowerCase().includes(val));
    });
    this.rows = temp;
  }

  toggleEstado(row: any): void {
  const nuevoEstatus = row.estatus === 1 ? 0 : 1;
  const textoAccion = nuevoEstatus === 1 ? 'activado' : 'desactivado';

  this.residentesService.actualizarPadron(row.id, { estatus: nuevoEstatus })
    .then(respuestaApi => {
      if (respuestaApi.success) {

        this.tempRows = this.tempRows.map(item => {
          if (item.id === row.id) {
            return { ...item, estatus: nuevoEstatus };
          }
          return item;
        });
        if(nuevoEstatus && !row.nombreCompleto.toLowerCase().includes('vip') ){
          this.obtenerPadron();
        }else{
          this.rows = [...this.tempRows];
        }

        this.toastr.success(`Registro ${textoAccion} correctamente`);

      } else {
        this.toastr.error(respuestaApi.message || 'No se pudo actualizar el estatus');
      }
    })
    .catch(error => {
      console.error('Error al actualizar estatus:', error);
      this.toastr.error('Ocurrió un error al comunicarse con el servidor');
    });
}

  mostarModalEditNuevo(modo : boolean){
    this.formNuevoEditarResidente = modo;
  }

  cerrarModalEditNuevo(){
    this.filaEdicion = -1;
    this.residenteForm.reset();
    this.formNuevoEditarResidente = false;
  }

  cerrarModalAsignar(){
    this.filaEdicion = -1;
    this.padronId = -1;
    this.mostrarModalAsignar = false;
  }

  asignarNuevo(row:any){
    console.log(row);
    this.filaEdicion = row.id;
    this.residenteForm = this.formBuilder.group({
      id_padron:[{value: row.id_padron, disabled: true}],
      nombre: ['',[Validators.required]],
      apellido_paterno: ['',[Validators.required]],
      apellido_materno: ['',[Validators.required]],
      no_tarjeton: [{ value: row.no_tarjeta, disabled: true }],
      fecha_registro: [{ value: row.fecha, disabled: true }]
    });
    this.formNuevoEditarResidente = true;
  }

  async GuardarCambios() {
    //validadores
    if (this.residenteForm.invalid) {
      this.residenteForm.markAllAsTouched();
      this.toastr.warning('Favor de completar los campos');
      return;
    }
    const formValues = this.residenteForm.getRawValue();

    // Nueva Persona
    const nuevaPersona = {
      nombre: formValues.nombre?.toUpperCase() || '',
      apellido_paterno: formValues.apellido_paterno?.toUpperCase() || '',
      apellido_materno: formValues.apellido_materno?.toUpperCase() || '',
      fecha_creacion: formValues.fecha_registro
    };

    try {
      // se crea la nueva persona
      const resPersona = await this.residentesService.crearPersona(nuevaPersona);

      if (!resPersona.success || !resPersona.data || !resPersona.data.id) {
        this.toastr.error(resPersona.message || 'Error al guardar los datos de la persona.');
        return;
      }
      const idPersonaCreada = resPersona.data.id;
      const idPadron = formValues.id_padron; 
      const padronUpdate = {
        id_persona: idPersonaCreada
      };

      //se asigna a la nueva persona en la fila del padron
      const resPadron = await this.residentesService.actualizarPadron(idPadron, padronUpdate);

      if (resPadron.success) {
        //se elimina de los pendientes de registro
        this.residentesService.actualizarPreRegistro(this.filaEdicion,{procesado: 1});
        this.toastr.success('Cambios guardados correctamente.');
        this.actualizarFilasLocales(idPadron, resPadron.data);
        this.cerrarModalEditNuevo();
      } else {
        this.toastr.error(resPadron.message || 'Error al vincular la persona con el padrón.');
      }

    } catch (error) {
        console.error('Error en el proceso de GuardarCambios:', error);
        this.toastr.error('Ocurrió un error inesperado en el servidor.');
    }
  }

  actualizarFilasLocales(id: number, datos: any){
    this.tempFilas = this.tempFilas.filter(item => item.id !== id);
    this.filas = [...this.tempFilas];
    this.obtenerPadron();
  }
  
  asignarExistente(row: any){
    this.filaEdicion = row.id;
    this.padronId = row.id_padron
    this.mostrarModalAsignar = true;
  }

  filtrarOpciones(): void {
    const termino = this.busquedaCombo.trim().toLowerCase();
    this.desplegado = true;

    if (!termino) {
      this.personasFiltradas = [...this.allpersonas];
      this.personaSeleccionada = null;
      return;
    }

    this.personasFiltradas = this.allpersonas.filter(item =>
      (item.nombre.toLowerCase() + ' ' + 
      item.apellido_paterno.toLowerCase() + ' ' + 
      item.apellido_paterno.toLowerCase()).includes(termino)
    );
  }

  alPerderFoco(): void {
    setTimeout(() => {
      this.desplegado = false;
    }, 300);
  }
  
  seleccionarOpcion(opcion: ResPersona): void {
    this.personaSeleccionada = opcion;
    this.busquedaCombo = opcion.nombre + ' ' + opcion.apellido_paterno + ' ' + opcion.apellido_materno;
    this.desplegado = false;
  }

  async asignarPersona(){
    if (!this.personaSeleccionada) {
      return;
    }
    
    await this.residentesService.actualizarPadron(this.padronId, {id_persona: this.personaSeleccionada.id}).then(
      respuesta_api => {
        if(respuesta_api.success){
          this.residentesService.actualizarPreRegistro(this.filaEdicion, {procesado: 1});
          this.toastr.success('Cambios guardados correctamente.');
          this.actualizarFilasLocales(this.filaEdicion, respuesta_api.data);
          this.cerrarModalAsignar();
        }
      }
    )
      

  }
}
